import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../store';
import { noFilterView } from '../store/viewsSlice';
import { SavedView } from '../viewUtilities';

export const getDefaultViewOrViewIdForUser = (savedViews: readonly SavedView[]) => {
  const userDefaultView = savedViews.find((view) => view.isDefault);
  return userDefaultView?.id ?? noFilterView;
};

export const getActiveViewOrViewId = createSelector(
  (state: RootState) => state.views.savedViews,
  (state: RootState) => state.views.activeView,
  (savedViews, activeView) => (activeView === 'default' ? getDefaultViewOrViewIdForUser(savedViews) : activeView),
);

export const getActiveView = createSelector(
  (state: RootState) => state.views.savedViews,
  getActiveViewOrViewId,
  (savedViews, activeViewOrViewId) => {
    if (typeof activeViewOrViewId === 'number') {
      const savedView = savedViews.find((view) => view.id === activeViewOrViewId);
      if (!savedView) console.error('View not found.');
      return savedView ?? noFilterView;
    }
    return activeViewOrViewId;
  },
);
